import { Injectable } from '@angular/core';
import { AbstractControl } from "@angular/forms";
import { FlatService } from "./flat.service";

@Injectable({
    providedIn: 'root'
})
export class FormHelperService {

    constructor(private flat: FlatService) {
    }

    public setSymfonyFormErrors(form: AbstractControl, errors: any, ignoreExtras = false) {
        if (!errors){
            return;
        }
        const formErrors = this.flat.flatten(errors, {safe: true});
        Object.keys(formErrors).forEach(fieldPath => {
            const fieldErrors = formErrors[fieldPath] as string[];
            const field = form.get(fieldPath);
            if (field) {
                field.setErrors(fieldErrors);
            } else if (!ignoreExtras) {
                console.error(`${fieldPath}: ${fieldErrors}`);
            }
        });
    }
}
